import styled from "@emotion/styled";
import { Table } from "@kaltura/ds-react-components";

export const StyledTable = styled(Table)(({ theme }) => ({
    "& thead th span": {
        fontSize: theme.typography.pxToRem(13),
    },
}));
